import { libraryInit, upsertLibrary } from "../../../redux/index";
import { findWorkspaceById } from "../../../redux/memoizedSelectors";
import { currentWorkspaceId } from "index";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { PageTemplate } from "shared/global-layouts/PageTemplate";
import { FlexColumnGap, GenericButton } from "shared/ui-basics";
import { EMPTY_GUID, encode } from "utils/helpers";
import { LibraryListCard } from "../components/LibraryListCard";
import { Library } from "../types";
import DataLoader from "shared/components/data-loader";

const Libraries: React.FC = () => {
	return (<LoadedLibrariesMenu />
	);
};

const LoadedLibrariesMenu: React.FC = () => {
	const { t } = useTranslation();
	const history = useHistory();

	const currentWorkspace = useSelector(findWorkspaceById(currentWorkspaceId));
	const subscriptionPlan = useSelector((state: any) => state.auth?.userInfo?.UserSubscriptionPlanName);
	const isStandard = subscriptionPlan === "Standard";
	const librariesData = useSelector((state) => getLibrariesSelector(state, isStandard));

	const handleCreate = () => {
		upsertLibrary({
			library: { id: EMPTY_GUID, name: encode(t("NEW_LIBRARY")), description: "" },
			onSuccess: ({ id }) => history.push(`/library-custom?id=${id}&isCreate=true`),
			displayToast: "CREATE",
		});
	};

	return (
		<PageTemplate classNames="container pt-5" pageTitle={`${currentWorkspace?.name} ${t("LIBRARIES")}`} maxWidth={1200}>
			{!isStandard && (
				<GenericButton className="mb-4" variant="primary" icon="SQUARE_PLUS" iconClassName="me-1" onClick={handleCreate}>
					{t("NEW_LIBRARY")}
				</GenericButton>
			)}
			<DataLoader reduxActions={[libraryInit] as any} disabledSpinner={true}>
				<FlexColumnGap gap="16">
					{librariesData?.map((data, i) => (
						<LibraryListCard key={i} data={data} />
					))}
				</FlexColumnGap>
			</DataLoader>
		</PageTemplate>
	);
};

const getLibrariesSelector = (state: any, isStandard: boolean) => {
	const libraries = state.libraries;
	const data = [
		{
			name: "Touchpoints",
			id: EMPTY_GUID,
			description: "TOUCHPOINTS_SWIMLANES_DESCRIPTION",
			url: "touchpoints",
			icon: "bullseye-pointer",
			nRecords: libraries?.touchPoint?.length,
		},
		{ name: "Stickers", id: EMPTY_GUID, description: "STICKERS_DESCRIPTION", url: "stickers", icon: "icons", nRecords: libraries?.icons?.length },
		{
			name: "Systems",
			description: "SYSTEMS_SWIMLANES_DESCRIPTION",
			url: "custom",
			id: "systems",
			icon: "window",
			nRecords: libraries?.customLibraries?.find((lib: Library) => lib?.name === "Systems" && !lib?.isCustom)?.values?.length,
		},
		{
			name: "Departments",
			description: "DEPARTMENTS_SWIMLANES_DESCRIPTION",
			url: "custom",
			id: "departments",
			icon: "user-group",
			nRecords: libraries?.customLibraries?.find((lib: Library) => lib?.name === "Departments" && !lib?.isCustom)?.values?.length,
		},
	];

	if (!isStandard) {
		data.push({
			name: "Brand Values",
			id: EMPTY_GUID,
			description: "BRAND_VALUES_DESCRIPTION",
			url: "brandvalues",
			icon: "book-blank",
			nRecords: libraries?.brandValues?.length,
		});
		data.push({ name: "Measures", id: EMPTY_GUID, description: "MEASURES_DESCRIPTION", url: "measures", icon: "chart-mixed", nRecords: libraries?.measures?.length });
	}

	libraries?.customLibraries?.forEach((library: Library) => {
		if (library?.isCustom)
			data.push({ library, name: library.name, url: "custom", id: library.id, icon: "bookmark", description: library?.description, isCustom: true, nRecords: library?.values?.length });
	});

	return data;
};
Libraries.displayName = "Libraries";
export default Libraries;
